import React from "react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const MyAreaChart = ({ data }) => {
  return (
    <div>
      <h1 className="caption">INVESTMENT VS REVENUE</h1>
      <AreaChart width={600} height={400} data={data}>
        <Area type="monotone" dataKey="revenue" stroke="cyan" fill="cyan" />
        <Area
          type="monotone"
          dataKey="investment"
          stroke="rgb(244, 161, 244)"
          fill="rgb(244, 161, 244)"
        />
        <XAxis dataKey={"month"}></XAxis>
        <YAxis></YAxis>
        <CartesianGrid stroke="#ccc"></CartesianGrid>
        <Tooltip></Tooltip>
      </AreaChart>
    </div>
  );
};

export default MyAreaChart;
